export default __webpack_public_path__ + "static/media/rupee-sign.4e2d43cc.svg";